import { Expression } from '@handlebars/parser/types/ast';
import { createSubExpression } from 'modules/handlebars/domain/expression/utils/createSubExpression';
import { createHash } from 'modules/handlebars/domain/hash/utils';
import { createPathExpression } from 'modules/handlebars/domain/expression/utils';
import { IterableMustachePaths } from 'modules/handlebars/domain/statement/types';

export const createDateMathSubExpression = (
  dateParameter: Expression,
  relativeDateEquation: Expression,
) =>
  createSubExpression({
    hash: createHash([]),
    params: [dateParameter, relativeDateEquation],
    path: createPathExpression(IterableMustachePaths.DateMath),
  });
